// extracted by mini-css-extract-plugin
export default {"container":"Button_container__8JaxQ","text":"Button_text__+IjL9"};